import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Route from "./Routes";
import PublicRoutes from "./Routes/PublicRoutes";
import "./assets/scss/themes.scss";

import { checkTokenExpiration } from "./slices/thunks";
import AuthProtected from "./Routes/AuthProtected";
import { useAuth } from "./Provider/AuthProvider";
// @ts-ignore
import Cookies from "js-cookie";

function App() {
    const navigate = useNavigate();
    const { user, setAllowedInterfaces } = useAuth();

    const COOKIE_NAME = "allowedInterfaces";
    const DEFAULT_VALUE = ["caisse", "vendeur", "commandes" , "stock"];
    const EXPIRATION_DAYS = 30;

    const handleCookie = () => {
        const cookie = Cookies.get(COOKIE_NAME);
        if (!cookie) {
            Cookies.set(COOKIE_NAME, JSON.stringify(DEFAULT_VALUE), { expires: 1 });
        } else {
            try {
                const parsed = JSON.parse(cookie);
                if (Array.isArray(parsed)) {
                    Cookies.set(COOKIE_NAME, JSON.stringify(parsed), { expires: EXPIRATION_DAYS });
                } else {
                    Cookies.set(COOKIE_NAME, JSON.stringify(DEFAULT_VALUE), { expires: EXPIRATION_DAYS });
                }
            } catch {
                Cookies.set(COOKIE_NAME, JSON.stringify(DEFAULT_VALUE), { expires: EXPIRATION_DAYS });
            }
        }
    };

    useEffect(() => {
        checkTokenExpiration(navigate);

        // Check cookie on mount
        handleCookie();

        const interval = setInterval(() => {
            checkTokenExpiration(navigate);
            handleCookie(); // refresh cookie periodically
        }, 5000); // 5 seconds for testing

        return () => clearInterval(interval);
    }, [user, navigate]);

    return (
        <React.Fragment>
            {user ? (
                <AuthProtected>
                    <Route />
                </AuthProtected>
            ) : (
                <PublicRoutes />
            )}
        </React.Fragment>
    );
}

export default App;
